// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"fe66e248","703":"d8ee617f","787":"c9f25c6e"}[chunkId] + ".chunk.js";
};